export enum roles {
  SUPER_ADMIN = "super_admin",
  ORG_ADMIN = "org_admin",
  BRANCH_ADMIN = "branch_admin",
  MEMBER = "member",
}

export enum roleLabels {
  SUPER_ADMIN = "Super Admin",
  ORG_ADMIN = "Organization Admin",

  MEMBER = "Member",
}

export enum invitations {
  USED = "used",
  EXPIRED = "expired",
  PENDING = "pending",
}
